module.exports = __webpack_public_path__ + "img/logo.63a7d78d.svg";